import { render, staticRenderFns } from "./twoGameView.vue?vue&type=template&id=47041fa3"
import script from "./twoGameView.vue?vue&type=script&lang=js"
export * from "./twoGameView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports